import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}

export const getTotalPreDocumento = async (oid: number): Promise<number> => {
  try {
    const res = await apiClient.post<ApiResponse<number>>(
      Endpoints.PagoPredocumento,
      {
        oidLiquidacion: oid,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
